module.exports = __webpack_public_path__ + "static/img/icon_arrow_left_24.1a2162d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/educal/icon_arrow_left_24.svg
// module id = XvGr
// module chunks = 10